const EkomLogo = ({ color = "currentColor", size = 120 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 914.88 914.999994"
    fill={color}
    preserveAspectRatio="xMidYMid meet"
  >
    <title>EKOM logo</title>
    <defs>
      <clipPath id="0ef41570b2">
        <path
          d="M 3.566406 119 L 910.949219 119 L 910.949219 796 L 3.566406 796 Z M 3.566406 119 "
          clipRule="nonzero"
        />
      </clipPath>
    </defs>
    <g clipPath="url(#0ef41570b2)">
      <path
        d="M 150.476562 389.96875 C 178.382812 311.980469 253.097656 255.421875 339.875 254.882812 C 449.15625 253.984375 546.015625 201.390625 607.589844 119.796875 L 341.496094 119.796875 C 231.671875 119.617188 133.554688 172.75 71.621094 254.882812 C 41.914062 294.148438 20.671875 340.257812 10.410156 389.96875 C -31.71875 595.300781 124.011719 793.0625 337.714844 795.40625 L 607.40625 795.40625 C 546.375 714.355469 449.695312 661.402344 341.316406 660.320312 C 253.996094 659.78125 178.742188 604.484375 150.296875 525.054688 L 337.714844 525.054688 C 596.605469 525.054688 825.429688 360.25 910.949219 119.617188 L 764.9375 119.617188 C 687.882812 281 523.871094 389.789062 339.15625 389.96875 Z M 682.664062 497.675781 C 634.773438 526.316406 582.921875 549.191406 528.191406 565.21875 C 631.710938 611.148438 715.96875 693.101562 764.757812 795.40625 L 910.769531 795.40625 C 867.921875 674.730469 787.445312 570.441406 682.484375 497.675781 Z M 682.664062 497.675781 "
        fillOpacity="1"
        fillRule="evenodd"
      />
    </g>
  </svg>
);
export default EkomLogo;
